/**
 * Etiquetas legibles para los modulos y acciones del catalogo de permisos
 * (backend: columnas `module` / `action` de la tabla `permissions`, V96).
 * Usado por el panel administrativo rol -> permisos (Etapa 4).
 */

export const PERMISSION_MODULE_LABELS: Record<string, string> = {
  SALES: 'Ventas',
  PURCHASES: 'Compras',
  QUOTATIONS: 'Cotizaciones',
  CASH: 'Caja',
  INVENTORY: 'Inventario',
  CATALOG: 'Catalogo',
  PRICING: 'Precios y promociones',
  PAYABLES: 'Cuentas por pagar',
  RECEIVABLES: 'Cuentas por cobrar',
  REPORTS: 'Reportes',
  DASHBOARD: 'Tableros',
  RESTAURANT: 'Restaurante',
  USERS: 'Usuarios y roles',
  SETTINGS: 'Configuracion',
  HACIENDA: 'Hacienda / DTE',
  HARDWARE: 'Hardware',
  PLATFORM: 'Plataforma',
};

export const moduleLabel = (code?: string | null): string => {
  if (!code) return 'Otros';
  return PERMISSION_MODULE_LABELS[code] ?? code;
};

export const PERMISSION_ACTION_LABELS: Record<string, string> = {
  VIEW: 'Ver',
  CREATE: 'Crear',
  EDIT: 'Editar',
  DELETE: 'Eliminar',
  MANAGE: 'Gestionar',
  APPROVE: 'Aprobar',
  CONFIRM: 'Confirmar',
  CANCEL: 'Cancelar',
  FINALIZE: 'Finalizar',
  VOID: 'Anular',
  EXPORT: 'Exportar',
  REPRINT: 'Reimprimir',
  SEND_EMAIL: 'Enviar correo',
  PAY: 'Registrar pago',
  ADVANCE: 'Avanzar',
  LOCK: 'Bloquear',
  RESET_PASSWORD: 'Restablecer clave',
  RUN: 'Ejecutar',
  SWITCH: 'Cambiar',
  OPEN: 'Abrir',
  CLOSE_BILL: 'Cerrar cuenta',
  ADVANCED: 'Avanzado',
  SPECIAL_OPS: 'Operaciones especiales',
  CREDIT_NOTE: 'Nota de credito',
  DEBIT_NOTE: 'Nota de debito',
  IMPORT: 'Importar',
  RETURN: 'Retorno',
  CONSUMPTION: 'Consumo',
  INITIAL_STOCK: 'Stock inicial',
  STOCK_SETTINGS: 'Ajustes de stock',
  REGISTER_PAYMENT: 'Registrar pago',
  HISTORY_VIEW: 'Ver historial',
  AGING_VIEW: 'Ver antiguedad',
  PENDING_SALES_CANCEL: 'Anular venta pendiente',
  DRAWER_OPEN: 'Abrir gaveta',
  SESSION_OPEN: 'Abrir sesion',
  SESSION_CLOSE: 'Cerrar sesion',
  INCOME: 'Ingreso',
  WITHDRAWAL: 'Retiro',
  REFUND: 'Reembolso',
  ADJUSTMENT: 'Ajuste',
  REPORTS: 'Reportes',
  TEST: 'Probar',
};

export const actionLabel = (code?: string | null): string => {
  if (!code) return '';
  return (
    PERMISSION_ACTION_LABELS[code] ??
    code
      .toLowerCase()
      .split('_')
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ')
  );
};
